import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Featutres from './components/Features';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';
import WhatItSolves from './components/WhatItSolves';
import ContactUs from './components/ContactUs';
import Clients from './components/Clients';
function App() {
  return (
    <div className="App">
      <Header />
      <WhatItSolves />
      <Testimonials />
      <Clients/>
      {/*<Pricing/>*/}
      <Featutres/>
      <HowItWorks/>
      <ContactUs/>
      <Footer />
      
   </div>
  );
}

export default App;
